import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant2PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 1080 638",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.563 271.551C78.2025 326.145 87.629 382.391 107.688 433.947C124.308 476.612 150.264 516.865 187.791 543.044C214.552 561.719 248.64 572.709 280.136 564.176C329.904 550.684 356.039 493.008 354.074 441.497C352.108 389.986 329.636 341.781 313.598 292.772C297.559 243.763 288.311 188.097 311.721 142.126C339.197 88.1136 407.104 63.14 466.879 73.0133C524.466 82.4845 579.104 124.926 589.335 182.379C595.545 217.315 585.359 253.056 572.18 285.981C559 318.907 542.604 350.94 535.546 385.697C528.487 420.455 532.195 459.68 555.516 486.396C585.046 520.305 636.78 524.549 680.786 515.212C733.458 504.043 788.23 487.066 839.384 470.179C895.318 451.728 952.1 441.184 1009.24 426.263",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant2PathwayIllustration as default };
